module.exports = __webpack_public_path__ + "static/media/tick-green.97eb60c8.svg";